// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/","redirect":"/bulletin","parentId":"@@/global-layout","id":"1"},"2":{"name":"信息中心","title":"信息中心","path":"/bulletin","exact":true,"parentId":"@@/global-layout","id":"2"},"3":{"name":"公告详情","title":"公告详情","path":"/detail","exact":true,"parentId":"@@/global-layout","id":"3"},"@@/global-layout":{"id":"@@/global-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__bulletin__index" */'@/pages/bulletin/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__detail__index" */'@/pages/detail/index.tsx')),
'@@/global-layout': React.lazy(() => import(/* webpackChunkName: "layouts__index" */'/usr/src/app/src/layouts/index.tsx')),
},
  };
}
